import { defineComponent as d, openBlock as n, createElementBlock as r, createElementVNode as a, createTextVNode as f, toDisplayString as u, renderSlot as c } from "vue";
import { _ as m } from "../../../_plugin-vue_export-helper-dad06003.js";
const b = d({
  name: "VUploadField",
  emits: ["upload-field:files-selected"],
  props: {
    label: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: !0
    },
    accept: {
      type: String,
      default: ""
    }
  },
  setup(e, { emit: l }) {
    return {
      filesSelected: (t) => {
        const o = t.target.files, i = Array.from(o);
        l("upload-field:files-selected", i), t.target.value = null;
      }
    };
  }
}), h = { class: "hobi-form-input-field hobi-form-field" }, _ = {
  class: "hobi-label hobi-label--upload",
  for: "hobi-upload"
}, y = ["accept", "multiple"];
function S(e, l, s, t, o, i) {
  return n(), r("div", h, [
    a("label", _, [
      f(u(e.label) + " ", 1),
      c(e.$slots, "default")
    ]),
    a("input", {
      id: "hobi-upload",
      class: "hobi-input hobi-input--file",
      type: "file",
      name: "hobi-upload",
      "aria-describedby": "hobi-upload",
      accept: e.accept,
      multiple: e.multiple,
      onChange: l[0] || (l[0] = (p) => e.filesSelected(p))
    }, null, 40, y)
  ]);
}
const V = /* @__PURE__ */ m(b, [["render", S]]);
export {
  V as default
};
